<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag'
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: CFOP_EDIT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.adminContext.cfop;
          this.extraData = response.data;
          // console.log("extra", this.extraData);
          // this.extraData.allAvailableNcms = [this.editableEntry.ncm]
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(taxationGroup) {
      this.pageLoading = true;
      // console.log(taxationGroup);
      var cleaned = this.deepFilterEntryWithAllowedFieldsForMutation(taxationGroup, this.editableEntry.validations);      
      //Gambis pq os campos estavam sendo limpos e nao achei pq !!!
      // cleaned.cultureIdsAttributes = taxationGroup.cultureIdsAttributes;
      // cleaned.subCultureIdsAttributes = taxationGroup.subCultureIdsAttributes;
      // console.log(cleaned);
      this.$apollo
        .mutate({
          mutation: UPDATE_CFOP_MUTATION,
          variables: {
            input: cleaned,
          }
        })
        .then(response => {
          var errors = response.data.updateCfop.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const CFOP_EDIT_QUERY = gql `
  query ($id: ID!){
    adminContext {
      cfop(id: $id) {
        id
        description
        text
        move
        bill
        purpose
        out
        verified
        validations
      }
      cfopPurposes
    }
  }
`;

const UPDATE_CFOP_MUTATION = gql `
  mutation($input: CfopUpdateInputObject!) {
    updateCfop(input: $input) {
      cfop{
        id
      }
      errors
    }
  }
`;


</script>

<style scoped></style>
